export const encodeFile = async (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
            const encodedFileWithData = fileReader.result.toString()
            const encodedFileWithoutData = encodedFileWithData.substring(encodedFileWithData.indexOf(',') + 1)
            resolve(encodedFileWithoutData)
        }
        fileReader.onerror = error => reject(error)
    }) as Promise<string>
}
